/**
 * Entry point. Orchestrates theme, routing, and page initialization.
 */

import './styles/style.css';
import { initializeTheme } from './theme.js';
import {
  pathnameToRoute,
  setPageInitializers,
  setupViewTransitionNavigation,
  bootstrapRoute
} from './routing.js';
import { setupModalListeners } from './modal.js';
import { initializePortfolio } from './portfolio.js';
import { initializePortfolioPage } from './portfolio-page.js';
import { setupNav } from './nav.js';
import { setupLinkGlitch } from './link-glitch.js';

function initializeHomePage() {
  initializePortfolio();
}

const ensureTargetInitialized = setPageInitializers(initializeHomePage, initializePortfolioPage);

document.addEventListener('DOMContentLoaded', () => {
  initializeTheme();
  setupNav();
  setupLinkGlitch();
  setupModalListeners();

  const route = pathnameToRoute(location.pathname);
  bootstrapRoute(route, ensureTargetInitialized);
  setupViewTransitionNavigation(ensureTargetInitialized);
});
